import { inject, observer } from "mobx-react";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Box from "react-raster";
import { match } from "react-router";
import { Heading, Icon, List, Paper } from "src/components";
import { theme } from "src/config";
import { MatchParams } from "src/routes";
import { RoutingStore, UserStore, AuthStore } from "src/stores";
import styled from "styled-components";

export interface IFaqDropDownProps {
  userStore?:   UserStore;
  authStore?:   AuthStore;
  routingStore?: RoutingStore;
  match: match<MatchParams>; // This is injected so it has to be called match
}

const HeaderBox = styled(Box)`
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-evenly;
  margin: 1.25rem;
`;

const DropDownHeader = styled.div`
  display: flex;
  color: ${theme.color.black};
  background: ${theme.color.white};
  border-radius: 0.25rem;
  width: 100%;
  margin-bottom: 2rem;
`;

const DropDownList = styled.div`
  display: flex;
  background: ${theme.color.white};
  color: ${theme.color.black};
  width: 100%;
  margin: 1.25rem;
  align-content: flex-start;
  justify-content: space-evenly;
`;

export const FaqDropDown = inject(
  "routingStore",
  "userStore"
)(
  observer((props: IFaqDropDownProps): JSX.Element => {
    const { t, i18n } = useTranslation();
    const { userStore } = props;
    const [isOpen, setIsOpen] = useState(false);
    const toggle = () => setIsOpen(!isOpen);
    const [isOpen1, setIsOpen1] = useState(false);
    const toggle1 = () => setIsOpen1(!isOpen1);
    const [isOpen2, setIsOpen2] = useState(false);
    const toggle2 = () => setIsOpen2(!isOpen2);

    return (
      <Paper style={theme.paper.regular}>
        <DropDownHeader onClick={toggle}>
          <HeaderBox>
            <Icon iconId="add" cursor="pointer" />
            <Heading type="h3" color={'black'}>
              {t("FAQ header placeholder 1")}
            </Heading>
          </HeaderBox>
        </DropDownHeader>

        {isOpen && (
          <DropDownList>
            <List items={["one", "two", "three", "four"]} />
          </DropDownList>
        )}

        <DropDownHeader onClick={toggle1}>
          <HeaderBox>
            <Icon iconId="add" cursor="pointer" />
            <Heading type="h3" color={'black'}>
              {t("FAQ header placeholder 2")}
            </Heading>
          </HeaderBox>
        </DropDownHeader>

        {isOpen1 && (
          <DropDownList>
            <List items={["one", "two", "three", "four"]} />
          </DropDownList>
        )}

        <DropDownHeader onClick={toggle2}>
          <HeaderBox>
            <Icon iconId="add" cursor="pointer" />
            <Heading type="h3" color={'black'}>
              {t("FAQ header placeholder 3")}
            </Heading>
          </HeaderBox>
        </DropDownHeader>

        {isOpen2 && (
          <DropDownList>
            <List items={["one", "two", "three", "four"]} />
          </DropDownList>
        )}
      </Paper>
    );
  })
);
